<template>
  <section class="relative isolate overflow-hidden py-24 sm:py-32">
    <div class="mx-auto max-w-7xl px-6 lg:px-8">
      <atomic-section-heading
        align="center"
        :kicker="kicker"
        :title="title"
        :description="description"
        class="mx-auto"
      />

      <div
        data-animate-group
        class="mt-16 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3"
      >
        <atomic-link-card
          v-for="link in links"
          :key="link.href"
          data-animate="fade-up"
          :link="link.href"
          :icon-name="link.iconName"
          :title="link.title"
          :description="link.description"
          :cta-label="link.ctaLabel"
        />
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import type { CrossLink } from 'types/navigation'

type Props = {
  links: CrossLink[],
  kicker?: string,
  title?: string,
  description?: string
}

const {
  kicker = 'Pour aller plus loin',
  title = 'Continuez votre visite.',
  description = 'Tout ce qu\'il faut pour créer, diffuser et équiper vos écrans, réuni au même endroit.'
} = defineProps<Props>()
</script>
